// Tiny toast stack used for missed_events on reconnect (PLAN.md §7.13).

import { useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { useStore } from '../store.js'

export function Toasts() {
  const toasts = useStore((s) => s.toasts)
  const dismiss = useStore((s) => s.dismissToast)

  useEffect(() => {
    if (toasts.length === 0) return
    const id = setInterval(() => {
      const now = Date.now()
      for (const t of toasts) {
        if (t.expiresAt <= now) dismiss(t.id)
      }
    }, 250)
    return () => clearInterval(id)
  }, [toasts, dismiss])

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-2 z-50 pointer-events-none">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 8 }}
            transition={{ type: 'spring', stiffness: 400, damping: 30 }}
            className="bg-white rounded-xl border border-light-grey shadow-big px-4 py-3 text-label text-black tabular-nums max-w-sm pointer-events-auto"
          >
            {t.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
